<template>
    <div class="tab-content" v-if="isActive">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: 'Tab'
            }
        },
        data () {
            return {
                isActive: true
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// client/components/SimpleTabs/Tab.vue